import { get, IRequestOptions, post } from '@apis/api';
import { CommonResponse } from '@wconcept/wconcept-common/models/common-response';
import { PopupResopnse } from '@wconcept/wconcept-common/models/renewal/popup';

const baseURL = process.env.NEXT_PUBLIC_DISPLAY_API_GATEWAY_URL;
const options = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8', // 필요에 따라 헤더 수정
    'DISPLAY-API-KEY': process.env.NEXT_PUBLIC_DISPLAY_API_GATEWAY_KEY || '',
  },
};
/**
 * 마케팅 팝업 조회.
 */
export const requestMarketingPopup = async (
  optionParams: IRequestOptions = {}
) => {
  const { data } = await get<CommonResponse<PopupResopnse>>({
    url: `/display/api/popup/v1/popup`,
    baseUrl: baseURL,
    options: { ...options, ...optionParams },
  });
  return data;
};
